module.exports = __webpack_public_path__ + "static/photo-female-f503732812e933176e903a2df027ea4c.jpg";